// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UDSi","right":"styles_right__1q7R0"};